import { createFileRoute, Outlet } from '@tanstack/react-router'
import { getOidc } from '@/features/oidc/oidc'
import { useControlsAndCapabilities } from '@/features/ctrls-and-caps/use-controls-and-capabilities'

export const Route = createFileRoute('/_app')({
  component: function RouteComponent() {
    useControlsAndCapabilities()
    return <Outlet />
  },

  beforeLoad: async ({ location }) => {
    const oidc = await getOidc()

    if (oidc.isUserLoggedIn) {
      return
    }

    const targetUrl = window.location.origin + location.href

    await oidc.login({
      redirectUrl: targetUrl,
      doesCurrentHrefRequiresAuth: window.location.href === targetUrl,
    })
  },
})
